const PhoneArea = {
  install (Vue) {
    Vue.prototype.$phoneArea = PhoneArea
  },
  areaNum: [
    {
      'num': 86,
      'name': {
        'cn': '中国',
        'pinyin': 'zhongguo',
        'en': 'china'
      }
    }, {
      'num': 93,
      'name': {
        'cn': '阿富汗',
        'pinyin': 'afuhan',
        'en': 'Afghanistan'
      }
    }, {
      'num': 355,
      'name': {
        'cn': '阿尔巴尼亚',
        'pinyin': 'aerbaniya',
        'en': 'Albania'
      }
    }, {
      'num': 213,
      'name': {
        'cn': '阿尔及利亚',
        'pinyin': 'aerjiliya',
        'en': 'Algeria'
      }
    }, {
      'num': 1684,
      'name': {
        'cn': '美属萨摩亚群岛',
        'pinyin': 'meishusamoyaqundao',
        'en': 'American Samoa'
      }
    }, {
      'num': 376,
      'name': {
        'cn': '安道尔',
        'pinyin': 'andaoer',
        'en': 'Andorra'
      }
    }, {
      'num': 244,
      'name': {
        'cn': '安哥拉',
        'pinyin': 'angela',
        'en': 'Angola'
      }
    }, {
      'num': 1264,
      'name': {
        'cn': '安圭拉岛',
        'pinyin': 'anguiladao',
        'en': 'Anguilla'
      }
    }, {
      'num': 1268,
      'name': {
        'cn': '安提瓜和巴布达',
        'pinyin': 'antiguahebabuda',
        'en': 'Antigua and Barbuda'
      }
    }, {
      'num': 54,
      'name': {
        'cn': '阿根廷',
        'pinyin': 'agenting',
        'en': 'Argentina'
      }
    }, {
      'num': 374,
      'name': {
        'cn': '亚美尼亚',
        'pinyin': 'yameiniya',
        'en': 'Armenia'
      }
    }, {
      'num': 297,
      'name': {
        'cn': '阿鲁巴岛',
        'pinyin': 'alubadao',
        'en': 'Aruba'
      }
    }, {
      'num': 61,
      'name': {
        'cn': '澳大利亚',
        'pinyin': 'aodaliya',
        'en': 'Australia'
      }
    }, {
      'num': 43,
      'name': {
        'cn': '奥地利',
        'pinyin': 'aodili',
        'en': 'Austria'
      }
    }, {
      'num': 994,
      'name': {
        'cn': '阿塞拜疆',
        'pinyin': 'asaibaijiang',
        'en': 'Azerbaijan'
      }
    }, {
      'num': 1242,
      'name': {
        'cn': '巴哈马',
        'pinyin': 'bahama',
        'en': 'Bahamas'
      }
    }, {
      'num': 973,
      'name': {
        'cn': '巴林',
        'pinyin': 'balin',
        'en': 'Bahrain'
      }
    }, {
      'num': 880,
      'name': {
        'cn': '孟加拉国',
        'pinyin': 'mengjialaguo',
        'en': 'Bangladesh'
      }
    }, {
      'num': 1246,
      'name': {
        'cn': '巴巴多斯',
        'pinyin': 'babaduosi',
        'en': 'Barbados'
      }
    }, {
      'num': 375,
      'name': {
        'cn': '白俄罗斯',
        'pinyin': 'baieluosi',
        'en': 'Belarus'
      }
    }, {
      'num': 32,
      'name': {
        'cn': '比利时',
        'pinyin': 'bilishi',
        'en': 'Belgium'
      }
    }, {
      'num': 501,
      'name': {
        'cn': '伯利兹',
        'pinyin': 'bolizi',
        'en': 'Belize'
      }
    }, {
      'num': 229,
      'name': {
        'cn': '贝宁',
        'pinyin': 'beining',
        'en': 'Benin'
      }
    }, {
      'num': 1441,
      'name': {
        'cn': '百慕大群岛',
        'pinyin': 'baimudaqundao',
        'en': 'Bermuda'
      }
    }, {
      'num': 975,
      'name': {
        'cn': '不丹',
        'pinyin': 'budao',
        'en': 'Bhutan'
      }
    }, {
      'num': 591,
      'name': {
        'cn': '玻利维亚',
        'pinyin': 'boliweiya',
        'en': 'Bolivia'
      }
    }, {
      'num': 387,
      'name': {
        'cn': '波斯尼亚和黑塞哥维那',
        'pinyin': 'bosiniyaheheisaigeweina',
        'en': 'Bosnia and Herzegovina'
      }
    }, {
      'num': 267,
      'name': {
        'cn': '博茨瓦纳',
        'pinyin': 'bociwana',
        'en': 'Botswana'
      }
    }, {
      'num': 55,
      'name': {
        'cn': '巴西',
        'pinyin': 'baxi',
        'en': 'Brazil'
      }
    }, {
      'num': 673,
      'name': {
        'cn': '文莱',
        'pinyin': 'wenlai',
        'en': 'Brunei Darussalam'
      }
    }, {
      'num': 359,
      'name': {
        'cn': '保加利亚',
        'pinyin': 'baojialiya',
        'en': 'Bulgaria'
      }
    }, {
      'num': 226,
      'name': {
        'cn': '布基纳法索',
        'pinyin': 'bujinafasuo',
        'en': 'Burkina Faso'
      }
    }, {
      'num': 257,
      'name': {
        'cn': '布隆迪',
        'pinyin': 'bulongdi',
        'en': 'Burundi'
      }
    }, {
      'num': 855,
      'name': {
        'cn': '柬埔寨',
        'pinyin': 'jianpuzhai',
        'en': 'Cambodia'
      }
    }, {
      'num': 237,
      'name': {
        'cn': '喀麦隆',
        'pinyin': 'kemailong',
        'en': 'Cameroon'
      }
    }, {
      'num': 1,
      'name': {
        'cn': '加拿大',
        'pinyin': 'jianada',
        'en': 'Canada'
      }
    }, {
      'num': 238,
      'name': {
        'cn': '佛得角',
        'pinyin': 'fodejiao',
        'en': 'Cape Verde'
      }
    }, {
      'num': 1345,
      'name': {
        'cn': '开曼群岛',
        'pinyin': 'kaimangqundao',
        'en': 'Cayman Islands'
      }
    }, {
      'num': 236,
      'name': {
        'cn': '中非',
        'pinyin': 'zhongfei',
        'en': 'Central African Republic'
      }
    }, {
      'num': 235,
      'name': {
        'cn': '乍得',
        'pinyin': 'zade',
        'en': 'Chad'
      }
    }, {
      'num': 56,
      'name': {
        'cn': '智利',
        'pinyin': 'zhili',
        'en': 'Chile'
      }
    }, {
      'num': 57,
      'name': {
        'cn': '哥伦比亚',
        'pinyin': 'gelunbiya',
        'en': 'Colombia'
      }
    }, {
      'num': 242,
      'name': {
        'cn': '刚果',
        'pinyin': 'gangguo',
        'en': 'Congo'
      }
    }, {
      'num': 682,
      'name': {
        'cn': '库克群岛',
        'pinyin': 'kukequndao',
        'en': 'Cook Islands'
      }
    }, {
      'num': 506,
      'name': {
        'cn': '哥斯达黎加',
        'pinyin': 'gesidalijia',
        'en': 'Costa Rica'
      }
    }, {
      'num': 385,
      'name': {
        'cn': '克罗地亚',
        'pinyin': 'keluodiya',
        'en': 'Croatia'
      }
    }, {
      'num': 53,
      'name': {
        'cn': '古巴',
        'pinyin': 'guba',
        'en': 'Cuba'
      }
    }, {
      'num': 357,
      'name': {
        'cn': '塞浦路斯',
        'pinyin': 'saipulusi',
        'en': 'Cyprus'
      }
    }, {
      'num': 420,
      'name': {
        'cn': '捷克共和国',
        'pinyin': 'jiekegongheguo',
        'en': 'Czech Republic'
      }
    }, {
      'num': 45,
      'name': {
        'cn': '丹麦',
        'pinyin': 'danmai',
        'en': 'Denmark'
      }
    }, {
      'num': 1809,
      'name': {
        'cn': '多米尼加共和国',
        'pinyin': 'duominijiagongheguo',
        'en': 'Dominican Republic'
      }
    }, {
      'num': 593,
      'name': {
        'cn': '厄瓜多尔',
        'pinyin': 'geguaduoer',
        'en': 'Ecuador'
      }
    }, {
      'num': 20,
      'name': {
        'cn': '埃及',
        'pinyin': 'aiji',
        'en': 'Egypt'
      }
    }, {
      'num': 503,
      'name': {
        'cn': '萨尔瓦多',
        'pinyin': 'saerwaduo',
        'en': 'El Salvador'
      }
    }, {
      'num': 240,
      'name': {
        'cn': '赤道几内亚',
        'pinyin': 'chidaojineiya',
        'en': 'Equatorial Guinea'
      }
    }, {
      'num': 372,
      'name': {
        'cn': '爱沙尼亚',
        'pinyin': 'aishaniya',
        'en': 'Estonia'
      }
    }, {
      'num': 251,
      'name': {
        'cn': '埃塞俄比亚',
        'pinyin': 'aisaiebiya',
        'en': 'Ethiopia'
      }
    }, {
      'num': 500,
      'name': {
        'cn': '福克兰群岛',
        'pinyin': 'fukelanqundao',
        'en': 'Falkland Islands'
      }
    }, {
      'num': 298,
      'name': {
        'cn': '法罗群岛',
        'pinyin': 'faluoqundao',
        'en': 'Faroe Islands'
      }
    }, {
      'num': 679,
      'name': {
        'cn': '斐济',
        'pinyin': 'feiji',
        'en': 'Fiji'
      }
    }, {
      'num': 358,
      'name': {
        'cn': '芬兰',
        'pinyin': 'fenlan',
        'en': 'Finland'
      }
    }, {
      'num': 33,
      'name': {
        'cn': '法国',
        'pinyin': 'faguo',
        'en': 'France'
      }
    }, {
      'num': 594,
      'name': {
        'cn': '法属圭亚那',
        'pinyin': 'fashuguiyana',
        'en': 'French Guiana'
      }
    }, {
      'num': 689,
      'name': {
        'cn': '法属波里尼西亚',
        'pinyin': 'fashubolinixiya',
        'en': 'French Polynesia'
      }
    }, {
      'num': 241,
      'name': {
        'cn': '加蓬',
        'pinyin': 'jiapeng',
        'en': 'Gabon'
      }
    }, {
      'num': 220,
      'name': {
        'cn': '冈比亚',
        'pinyin': 'gangbiya',
        'en': 'Gambia'
      }
    }, {
      'num': 995,
      'name': {
        'cn': '格鲁吉亚',
        'pinyin': 'gelujiya',
        'en': 'Georgia'
      }
    }, {
      'num': 49,
      'name': {
        'cn': '德国',
        'pinyin': 'deguo',
        'en': 'Germany'
      }
    }, {
      'num': 233,
      'name': {
        'cn': '加纳',
        'pinyin': 'jiana',
        'en': 'Ghana'
      }
    }, {
      'num': 350,
      'name': {
        'cn': '直布罗陀(英)',
        'pinyin': 'zhibuluotuo',
        'en': 'Gibraltar'
      }
    }, {
      'num': 30,
      'name': {
        'cn': '希腊',
        'pinyin': 'xila',
        'en': 'Greece'
      }
    }, {
      'num': 299,
      'name': {
        'cn': '格陵兰岛',
        'pinyin': 'gelinglandao',
        'en': 'Greenland'
      }
    }, {
      'num': 1809,
      'name': {
        'cn': '格林纳达',
        'pinyin': 'gelinnada',
        'en': 'Grenada'
      }
    }, {
      'num': 590,
      'name': {
        'cn': '瓜德罗普岛',
        'pinyin': 'guadeluopudao',
        'en': 'Guadeloupe'
      }
    }, {
      'num': 502,
      'name': {
        'cn': '危地马拉',
        'pinyin': 'weidimala',
        'en': 'Guatemala'
      }
    }, {
      'num': 224,
      'name': {
        'cn': '几内亚',
        'pinyin': 'jinaya',
        'en': 'Guinea'
      }
    }, {
      'num': 245,
      'name': {
        'cn': '几内亚比绍',
        'pinyin': 'jinayabisao',
        'en': 'Guinea-Bissau'
      }
    }, {
      'num': 592,
      'name': {
        'cn': '圭亚那',
        'pinyin': 'guiyana',
        'en': 'Guyana'
      }
    }, {
      'num': 509,
      'name': {
        'cn': '海地',
        'pinyin': 'haidi',
        'en': 'Haiti'
      }
    }, {
      'num': 504,
      'name': {
        'cn': '洪都拉斯',
        'pinyin': 'hongdulasi',
        'en': 'Honduras'
      }
    }, {
      'num': 852,
      'name': {
        'cn': '香港',
        'pinyin': 'xianggang',
        'en': 'Hong Kong'
      }
    }, {
      'num': 36,
      'name': {
        'cn': '匈牙利',
        'pinyin': 'xiongyali',
        'en': 'Hungary'
      }
    }, {
      'num': 354,
      'name': {
        'cn': '冰岛',
        'pinyin': 'bindao',
        'en': 'Iceland'
      }
    }, {
      'num': 91,
      'name': {
        'cn': '印度',
        'pinyin': 'yindu',
        'en': 'India'
      }
    }, {
      'num': 62,
      'name': {
        'cn': '印度尼西亚',
        'pinyin': 'yindunixiya',
        'en': 'Indonesia'
      }
    }, {
      'num': 98,
      'name': {
        'cn': '伊郎',
        'pinyin': 'yilang',
        'en': 'Iran'
      }
    }, {
      'num': 964,
      'name': {
        'cn': '伊拉克',
        'pinyin': 'yilake',
        'en': 'Iraq'
      }
    }, {
      'num': 353,
      'name': {
        'cn': '爱尔兰',
        'pinyin': 'aierlan',
        'en': 'Ireland'
      }
    }, {
      'num': 972,
      'name': {
        'cn': '以色列',
        'pinyin': 'yiselie',
        'en': 'Israel'
      }
    }, {
      'num': 39,
      'name': {
        'cn': '意大利',
        'pinyin': 'yidali',
        'en': 'Italy'
      }
    }, {
      'num': 1876,
      'name': {
        'cn': '牙买加',
        'pinyin': 'yamaijia',
        'en': 'Jamaica'
      }
    }, {
      'num': 81,
      'name': {
        'cn': '日本',
        'pinyin': 'riben',
        'en': 'Japan'
      }
    }, {
      'num': 962,
      'name': {
        'cn': '约旦',
        'pinyin': 'yuedao',
        'en': 'Jordan'
      }
    }, {
      'num': 7,
      'name': {
        'cn': '哈萨克斯坦',
        'pinyin': 'hasakesitan',
        'en': 'Kazakhstan'
      }
    }, {
      'num': 254,
      'name': {
        'cn': '肯尼亚',
        'pinyin': 'kenniya',
        'en': 'Kenya'
      }
    }, {
      'num': 965,
      'name': {
        'cn': '科威特',
        'pinyin': 'keweite',
        'en': 'Kuwait'
      }
    }, {
      'num': 7,
      'name': {
        'cn': '吉尔吉斯斯坦',
        'pinyin': 'jierjisita',
        'en': 'Kyrgyzstan'
      }
    }, {
      'num': 856,
      'name': {
        'cn': '老挝',
        'pinyin': 'laoguo',
        'en': 'Laos'
      }
    }, {
      'num': 371,
      'name': {
        'cn': '拉脱维亚',
        'pinyin': 'latuoweiya',
        'en': 'Latvia'
      }
    }, {
      'num': 961,
      'name': {
        'cn': '黎巴嫩',
        'pinyin': 'libanen',
        'en': 'Lebanon'
      }
    }, {
      'num': 266,
      'name': {
        'cn': '莱索托',
        'pinyin': 'laisuotuo',
        'en': 'Lesotho'
      }
    }, {
      'num': 231,
      'name': {
        'cn': '利比里亚',
        'pinyin': 'libiya',
        'en': 'Liberia'
      }
    }, {
      'num': 218,
      'name': {
        'cn': '利比亚',
        'pinyin': 'libiya',
        'en': 'Libya'
      }
    }, {
      'num': 423,
      'name': {
        'cn': '列支敦士登',
        'pinyin': 'liezhidunshideng',
        'en': 'Liechtenstein'
      }
    }, {
      'num': 370,
      'name': {
        'cn': '立陶宛',
        'pinyin': 'liwanyuan',
        'en': 'Lithuania'
      }
    }, {
      'num': 352,
      'name': {
        'cn': '卢森堡',
        'pinyin': 'lusenbao',
        'en': 'Luxembourg'
      }
    }, {
      'num': 853,
      'name': {
        'cn': '澳门',
        'pinyin': 'aomen',
        'en': 'Macau'
      }
    }, {
      'num': 389,
      'name': {
        'cn': '马其顿',
        'pinyin': 'maqidun',
        'en': 'Macedonia'
      }
    }, {
      'num': 261,
      'name': {
        'cn': '马达加斯加',
        'pinyin': 'madajiasida',
        'en': 'Madagascar'
      }
    }, {
      'num': 265,
      'name': {
        'cn': '马拉维',
        'pinyin': 'malawei',
        'en': 'Malawi'
      }
    }, {
      'num': 60,
      'name': {
        'cn': '马来西亚',
        'pinyin': 'malaixiya',
        'en': 'Malaysia'
      }
    }, {
      'num': 960,
      'name': {
        'cn': '马尔代夫',
        'pinyin': 'maerdaifu',
        'en': 'Maldives'
      }
    }, {
      'num': 223,
      'name': {
        'cn': '马里',
        'pinyin': 'mali',
        'en': 'Mali'
      }
    }, {
      'num': 356,
      'name': {
        'cn': '马耳他',
        'pinyin': 'maerta',
        'en': 'Malta'
      }
    }, {
      'num': 692,
      'name': {
        'cn': '马绍尔群岛',
        'pinyin': 'masaierqundao',
        'en': 'Marshall Islands'
      }
    }, {
      'num': 596,
      'name': {
        'cn': '马提尼克(法)',
        'pinyin': 'matinike',
        'en': 'Martinique'
      }
    }, {
      'num': 222,
      'name': {
        'cn': '毛里塔尼亚',
        'pinyin': 'maolitaniya',
        'en': 'Mauritania'
      }
    }, {
      'num': 230,
      'name': {
        'cn': '毛里求斯',
        'pinyin': 'laoliqiusi',
        'en': 'Mauritius'
      }
    }, {
      'num': 52,
      'name': {
        'cn': '墨西哥',
        'pinyin': 'moxige',
        'en': 'Mexico'
      }
    }, {
      'num': 373,
      'name': {
        'cn': '摩尔多瓦',
        'pinyin': 'moerduowa',
        'en': 'Moldova'
      }
    }, {
      'num': 377,
      'name': {
        'cn': '摩纳哥',
        'pinyin': 'monage',
        'en': 'Monaco'
      }
    }, {
      'num': 976,
      'name': {
        'cn': '蒙古',
        'pinyin': 'menggu',
        'en': 'Mongolia'
      }
    }, {
      'num': 382,
      'name': {
        'cn': '黑山共和国',
        'pinyin': 'heishangongheguo',
        'en': 'Montenegro'
      }
    }, {
      'num': 212,
      'name': {
        'cn': '摩洛哥',
        'pinyin': 'moluoge',
        'en': 'Morocco'
      }
    }, {
      'num': 258,
      'name': {
        'cn': '莫桑比克',
        'pinyin': 'mosanbike',
        'en': 'Mozambique'
      }
    }, {
      'num': 95,
      'name': {
        'cn': '缅甸',
        'pinyin': 'miandian',
        'en': 'Myanmar'
      }
    }, {
      'num': 264,
      'name': {
        'cn': '纳米比亚',
        'pinyin': 'namibiya',
        'en': 'Namibia'
      }
    }, {
      'num': 674,
      'name': {
        'cn': '瑙鲁',
        'pinyin': 'naolu',
        'en': 'Nauru'
      }
    }, {
      'num': 977,
      'name': {
        'cn': '尼泊尔',
        'pinyin': 'niboer',
        'en': 'Nepal'
      }
    }, {
      'num': 31,
      'name': {
        'cn': '荷兰',
        'pinyin': 'helan',
        'en': 'Netherlands'
      }
    }, {
      'num': 687,
      'name': {
        'cn': '新喀里多尼亚',
        'pinyin': 'xinkeliduoniya',
        'en': 'New Caledonia'
      }
    }, {
      'num': 64,
      'name': {
        'cn': '新西兰',
        'pinyin': 'xinxilan',
        'en': 'New Zealand'
      }
    }, {
      'num': 505,
      'name': {
        'cn': '尼加拉瓜',
        'pinyin': 'nijialagua',
        'en': 'Nicaragua'
      }
    }, {
      'num': 227,
      'name': {
        'cn': '尼日尔',
        'pinyin': 'nirier',
        'en': 'Niger'
      }
    }, {
      'num': 234,
      'name': {
        'cn': '尼日利亚',
        'pinyin': 'niriliya',
        'en': 'Nigeria'
      }
    }, {
      'num': 47,
      'name': {
        'cn': '挪威',
        'pinyin': 'nuowei',
        'en': 'Norway'
      }
    }, {
      'num': 968,
      'name': {
        'cn': '阿曼',
        'pinyin': 'aman',
        'en': 'Oman'
      }
    }, {
      'num': 92,
      'name': {
        'cn': '巴基斯坦',
        'pinyin': 'bajisitan',
        'en': 'Pakistan'
      }
    }, {
      'num': 680,
      'name': {
        'cn': '帕劳(美)',
        'pinyin': 'palao',
        'en': 'Palau'
      }
    }, {
      'num': 507,
      'name': {
        'cn': '巴拿马',
        'pinyin': 'banama',
        'en': 'Panama'
      }
    }, {
      'num': 675,
      'name': {
        'cn': '巴布亚新几内亚',
        'pinyin': 'babuyaxinjineiya',
        'en': 'Papua New Guinea'
      }
    }, {
      'num': 595,
      'name': {
        'cn': '巴拉圭',
        'pinyin': 'balagui',
        'en': 'Paraguay'
      }
    }, {
      'num': 51,
      'name': {
        'cn': '秘鲁',
        'pinyin': 'milu',
        'en': 'Peru'
      }
    }, {
      'num': 63,
      'name': {
        'cn': '菲律宾',
        'pinyin': 'feilvbin',
        'en': 'Philippines'
      }
    }, {
      'num': 48,
      'name': {
        'cn': '波兰',
        'pinyin': 'bolan',
        'en': 'Poland'
      }
    }, {
      'num': 351,
      'name': {
        'cn': '葡萄牙',
        'pinyin': 'putapya',
        'en': 'Portugal'
      }
    }, {
      'num': 974,
      'name': {
        'cn': '卡塔尔',
        'pinyin': 'kataer',
        'en': 'Qatar'
      }
    }, {
      'num': 262,
      'name': {
        'cn': '留尼汪岛',
        'pinyin': 'liuniwangdao',
        'en': 'Reunion'
      }
    }, {
      'num': 40,
      'name': {
        'cn': '罗马尼亚',
        'pinyin': 'luomaniya',
        'en': 'Romania'
      }
    }, {
      'num': 7,
      'name': {
        'cn': '俄罗斯',
        'pinyin': 'eluosi',
        'en': 'Russian Federation'
      }
    }, {
      'num': 966,
      'name': {
        'cn': '沙特阿拉伯',
        'pinyin': 'shatealabo',
        'en': 'Saudi Arabia'
      }
    }, {
      'num': 221,
      'name': {
        'cn': '塞内加尔',
        'pinyin': 'saineijiaer',
        'en': 'Senegal'
      }
    }, {
      'num': 381,
      'name': {
        'cn': '塞尔维亚',
        'pinyin': 'saierweiya',
        'en': 'Serbia'
      }
    }, {
      'num': 248,
      'name': {
        'cn': '塞舌尔',
        'pinyin': 'saisheer',
        'en': 'Seychelles'
      }
    }, {
      'num': 232,
      'name': {
        'cn': '塞拉利昂',
        'pinyin': 'sailalian',
        'en': 'Sierra Leone'
      }
    }, {
      'num': 65,
      'name': {
        'cn': '新加坡',
        'pinyin': 'xinjiabo',
        'en': 'Singapore'
      }
    }, {
      'num': 421,
      'name': {
        'cn': '斯洛伐克',
        'pinyin': 'siluofake',
        'en': 'Slovakia'
      }
    }, {
      'num': 386,
      'name': {
        'cn': '斯洛文尼亚',
        'pinyin': 'siluowenniya',
        'en': 'Slovenia'
      }
    }, {
      'num': 677,
      'name': {
        'cn': '阿罗门',
        'pinyin': 'aluomen',
        'en': 'Solomon Islands'
      }
    }, {
      'num': 252,
      'name': {
        'cn': '索马里',
        'pinyin': 'suomali',
        'en': 'Somalia'
      }
    }, {
      'num': 27,
      'name': {
        'cn': '南非',
        'pinyin': 'nanfei',
        'en': 'South Africa'
      }
    }, {
      'num': 34,
      'name': {
        'cn': '西班牙',
        'pinyin': 'xibanya',
        'en': 'Spain'
      }
    }, {
      'num': 94,
      'name': {
        'cn': '斯里兰卡',
        'pinyin': 'sililanka',
        'en': 'Sri Lanka'
      }
    }, {
      'num': 249,
      'name': {
        'cn': '苏丹',
        'pinyin': 'sudan',
        'en': 'Sudan'
      }
    }, {
      'num': 597,
      'name': {
        'cn': '苏里南',
        'pinyin': 'sulinan',
        'en': 'Suriname'
      }
    }, {
      'num': 268,
      'name': {
        'cn': '斯威士兰',
        'pinyin': 'siweishilan',
        'en': 'Swaziland'
      }
    }, {
      'num': 46,
      'name': {
        'cn': '瑞典',
        'pinyin': 'ruidian',
        'en': 'Sweden'
      }
    }, {
      'num': 41,
      'name': {
        'cn': '瑞士',
        'pinyin': 'ruishi',
        'en': 'Switzerland'
      }
    }, {
      'num': 963,
      'name': {
        'cn': '叙利亚',
        'pinyin': 'xuliya',
        'en': 'Syria'
      }
    }, {
      'num': 886,
      'name': {
        'cn': '台湾',
        'pinyin': 'taiwan',
        'en': 'Taiwan'
      }
    }, {
      'num': 7,
      'name': {
        'cn': '塔吉克斯坦',
        'pinyin': 'tajikesitan',
        'en': 'Tajikistan'
      }
    }, {
      'num': 255,
      'name': {
        'cn': '坦桑尼亚',
        'pinyin': 'tansanniya',
        'en': 'Tanzania'
      }
    }, {
      'num': 66,
      'name': {
        'cn': '泰国',
        'pinyin': 'taiguo',
        'en': 'Thailand'
      }
    }, {
      'num': 228,
      'name': {
        'cn': '多哥',
        'pinyin': 'duoge',
        'en': 'Togo'
      }
    }, {
      'num': 676,
      'name': {
        'cn': '汤加',
        'pinyin': 'tangjia',
        'en': 'Tonga'
      }
    }, {
      'num': 1868,
      'name': {
        'cn': '特立尼达和多巴哥',
        'pinyin': 'telinidaheduobage',
        'en': 'Trinidad and Tobago'
      }
    }, {
      'num': 216,
      'name': {
        'cn': '突尼斯',
        'pinyin': 'tunisi',
        'en': 'Tunisia'
      }
    }, {
      'num': 90,
      'name': {
        'cn': '土耳其',
        'pinyin': 'tuerqi',
        'en': 'Turkey'
      }
    }, {
      'num': 993,
      'name': {
        'cn': '土库曼斯坦',
        'pinyin': 'tukumansitan',
        'en': 'Turkmenistan'
      }
    }, {
      'num': 1649,
      'name': {
        'cn': '特克斯和凯科斯群岛',
        'pinyin': 'tekesihekaikesiqundao',
        'en': 'Turks and Caicos Islands'
      }
    }, {
      'num': 256,
      'name': {
        'cn': '乌干达',
        'pinyin': 'wuganda',
        'en': 'Uganda'
      }
    }, {
      'num': 380,
      'name': {
        'cn': '乌克兰',
        'pinyin': 'wukelan',
        'en': 'Ukraine'
      }
    }, {
      'num': 44,
      'name': {
        'cn': '英国',
        'pinyin': 'yingguo',
        'en': 'United Kingdom'
      }
    }, {
      'num': 1,
      'name': {
        'cn': '美国',
        'pinyin': 'meiguo',
        'en': 'United States'
      }
    }, {
      'num': 598,
      'name': {
        'cn': '乌拉圭',
        'pinyin': 'wulagui',
        'en': 'Uruguay'
      }
    }, {
      'num': 998,
      'name': {
        'cn': '乌兹别克斯坦',
        'pinyin': 'wuzibiekesitan',
        'en': 'Uzbekistan'
      }
    }, {
      'num': 678,
      'name': {
        'cn': '瓦努阿图',
        'pinyin': 'wanuatu',
        'en': 'Vanuatu'
      }
    }, {
      'num': 58,
      'name': {
        'cn': '委内瑞拉',
        'pinyin': 'weineiruila',
        'en': 'Venezuela'
      }
    }, {
      'num': 84,
      'name': {
        'cn': '越南',
        'pinyin': 'yuenan',
        'en': 'Vietnam'
      }
    }, {
      'num': 967,
      'name': {
        'cn': '也门',
        'pinyin': 'yemen',
        'en': 'Yemen'
      }
    }, {
      'num': 260,
      'name': {
        'cn': '赞比亚',
        'pinyin': 'zanbiya',
        'en': 'Zambia'
      }
    }, {
      'num': 263,
      'name': {
        'cn': '津巴布韦',
        'pinyin': 'jinbabuwei',
        'en': 'Zimbabwe'
      }
    }, {
      'num': 82,
      'name': {
        'cn': '韩国',
        'pinyin': 'hanguo',
        'en': 'Korea'
      }
    }, {
      'num': 971,
      'name': {
        'cn': '阿联酋',
        'pinyin': 'alianqiu',
        'en': 'United Arab Emirates'
      }
    }, {
      'num': 383,
      'name': {
        'cn': '科索沃',
        'pinyin': 'kesuowo',
        'en': 'The Republic of Kosovo'
      }
    }
  ],
  getEnum (data, key) {
    let obj
    data.forEach(e => {
      if (e.name.cn === key) {
        obj = e
        return
      }
    })
    return obj
  }
}
export default PhoneArea



// WEBPACK FOOTER //
// ./src/plugins/PhoneArea.js